import { ImageField } from "admin-on-rest";
import React from "react";

export const ImageFieldOrNull = ({record, ...props}) => {
  return (
    typeof record === 'object'
      ? <ImageField record={record} {...props} />
      : null
  )
}

export const format = (file) => {
  if (typeof file !== 'object') {
    return { preview: file, url: file }
  }
  return file
}

export const fixIfEmptyArray = (values, record, {initialValues}, fieldName) => {
  if (Array.isArray(values) && values.length === 0) {
    record[fieldName] = initialValues[fieldName]
  }
}



// WEBPACK FOOTER //
// ./src/common.js